import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('get', `/api/live_discussions/${liveID}/polls`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getAllPolls.js